// @ts-strict-ignore
import clsx from 'clsx'
import { FC, MouseEvent, useCallback, useState } from 'react'

import { Button, ButtonProps, Modal } from '@/shared/ui'

import { BasketClearModal } from '../basket-clear-modal/basket-clear-modal'

import styles from './basket-clear-button.module.scss'

export type ClearBasketButtonProps = ButtonProps<any>

/**
 * Clear all products in basket
 */
export const BasketClearButton: FC<ClearBasketButtonProps> = ({ className, onClick, ...props }) => {
	const [isModalOpen, setIsModalOpen] = useState(false)

	const handleOpen = useCallback((event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation()
		setIsModalOpen(true)
	}, [])

	const handleClose = useCallback(() => {
		setIsModalOpen(false)
	}, [])

	const handleConfirm = useCallback(() => {
		onClick?.()
		setIsModalOpen(false)
	}, [onClick])

	return (
		<>
			<Button
				theme="link"
				name="clear-cart"
				aria-label="Удалить все товары из корзины"
				className={clsx('clearBasket', styles.buttonClear, className)}
				onClick={handleOpen}
				{...props}>
				Очистить корзину
			</Button>
			<Modal isOpen={isModalOpen} onClose={handleClose} contentClassName={styles.modalContent}>
				<BasketClearModal onOk={handleConfirm} />
			</Modal>
		</>
	)
}
